const CHECKOUT = {
  order_or_request: 'Bestellung oder Anfrage',
  details: 'Details',
  summary: 'Zusammenfassung',
  order: 'Bestellung',
  request: 'Anfrage',
  continue_as: 'Weiter als {label}',
  lkw_ramp: 'Anlieferung mit Hebebühne und Hubwagen',
  delivery_date: 'Wunschliefertermin',
  buy_order: 'Bestellung zahlungspflichtig bestellen',
  place_request: 'Anfrage senden',
  contact_at_location: 'Kontakt Vorort',
  project: 'Project',
  binding_order: 'Bitte wählen Sie:',
  next_to_checkout: 'Weiter zum Checkout',
  type: 'Typ',
  adjoining_area: 'Anschlussfläche',
  reference_id: 'Referenz - / Bestellnummer',
};

export default CHECKOUT;
